import { hasPermission } from '@/utils'

export default {
  SET_NAV_MENU_ITEMS(state) {
    const menuItems = [
      {
        url: null,
        name: "Users",
        icon: "UsersIcon",
        i18n: "Usuários",
        submenu: [
          {
            url: '/users',
            name: "User",
            slug: "users-list",
            i18n: "Gestão de Usuários"
          }
        ]
      },
      {
        url: null,
        name: "Tenants",
        icon: "RssIcon",
        i18n: "Dashes",
        submenu: [
          {
            url: '/tenants',
            name: "TenantsCrud",
            slug: "tenant-list",
            i18n: "Gestão de Dashes"
          }
        ]
      },
      {
        url: null,
        name: "Access",
        icon: "UnlockIcon",
        i18n: "Access",
        submenu: [
          {
            url: '/roles/list',
            name: "roles-list",
            slug: "roles-list",
            i18n: "Roles",
          },
        ]
      },
      {
        url: null,
        name: "Analytics",
        icon: "BarChartIcon",
        i18n: "Dados e Métricas",
        submenu: [
          {
            url: '/dashboard/analytics',
            name: "dashboard-analytics",
            slug: "dashboard-analytics",
            i18n: "Analytics"
          },
          {
            url: '/dashboard/control-panel',
            name: "dashboard-control-panel",
            slug: "dashboard-control-panel",
            i18n: "Painel de Controle"
          },
          {
            url: '/dashboard/maria-panel',
            name: "dashboard-maria-panel",
            slug: "dashboard-maria-panel",
            i18n: "Painel da MarIa"
          },
          {
            url: '/dashboard/produtivity-report',
            name: "dashboard-produtivity-report",
            slug: "dashboard-produtivity-report",
            i18n: "Produtividade"
          },
          {
            url: '/dashboard/report',
            name: "dashboard-report",
            slug: "dashboard-report",
            i18n: "Métricas de Segurança"
          },
          {
            url: '/dashboard/report-smart',
            name: "dashboard-report-smart",
            slug: "dashboard-report-smart",
            i18n: "Métricas Inteligentes"
          }
        ]
      },
    ];

    const alwaysAllowed = [
      'help-support',
      'rules'
    ]

    state.navMenuItems = menuItems.filter(item => {
      if (item.url !== null) {
        return hasPermission(item.slug) ? item : false
      } else {
        item.submenu = item.submenu.filter(sub => {
          if (alwaysAllowed.indexOf(sub.slug) >= 0) {
            return item
          }

          return hasPermission(sub.slug) ? item : false
        })

        if (item.submenu.length === 0) {
          return false
        }
      }

      return item
    })
  }
}
